import {
  Table, TableBody, TableCell, TableContainer, TableHead,
  TableRow, Paper, Typography, Checkbox
} from '@mui/material';
import React, { useState, useEffect } from 'react';
import request from '../../../utils/request';
import { useDispatch } from 'react-redux';
import { updateSumInsuredSectionData } from 'src/features/rfqDataSlice';

function SumInsuredLabelvaluepair({ policyDetails }) {
  const dispatch = useDispatch();
  const [labelValuePairDatas, setLabelValuePairDatas] = useState([]);
  const [selectedRows, setSelectedRows] = useState([]);

  useEffect(() => {
    if (policyDetails?.policyId) {
      getSavedLabelValueDatas();
    }
  }, [policyDetails]);

  const getSavedLabelValueDatas = async () => {
    request({
      url: 'insurancePolicy/getSumInsuredList',
      method: 'post',
      data: {
        policyId: policyDetails.policyId,
        sectionId: policyDetails.id,
        listType: 'labelValuePair',
      }
    }).then(
      (response) => {
        const result = response.data.map((labelValueData) => ({
          description: labelValueData?.description,
          sumInsured: labelValueData?.sumInsured,
          id: labelValueData?.id,
          savedStatus: true,
          isSuminsured: labelValueData?.isSuminsured
        }));
        setLabelValuePairDatas(result);
        document.getElementById('sumInsuredBox').style.display = 'block';
      },
      (error) => {
        console.log(error);
      }
    );
  };

 const handleCheckboxChange = (rowData, isChecked) => {
  const updatedSelection = isChecked
    ? [...selectedRows, rowData]
    : selectedRows.filter(item => item.id !== rowData.id); // 👈 FIXED

  setSelectedRows(updatedSelection);

  dispatch(updateSumInsuredSectionData({
    sumInsuredSectionData: {
      [policyDetails.id]: {
        sectionType: 'labelValuePair',
        groups: [],
        labelValuePairItem: updatedSelection
      }
    }
  }));
};


const isRowSelected = (rowData) => {
  return selectedRows.some(item => item.id === rowData.id); // or use item.description if id is not reliable
};


  return (
    <TableContainer
      component={Paper}
      sx={{ maxHeight: '500px', overflowY: 'auto', mt: 1, boxShadow: 'unset' }}
    >
      <Table size="small" aria-label="a dense table" style={{ margin: '10px 0' }}>
        <TableHead>
          {policyDetails?.sectionName && (
            <TableRow>
              <TableCell
                className='heading'
                colSpan={3}
                style={{
                  fontWeight: 'bold',
                  textAlign: 'left',
                  background: 'rgb(9 84 174)',
                  color: '#fff',
                  paddingTop: '2px',
                  paddingBottom: '2px'
                }}
              >
                {policyDetails?.sectionName}
              </TableCell>
            </TableRow>
          )}
          <TableRow>
            <TableCell style={{ width: '40px' }}></TableCell>
            <TableCell style={{ width: '470px', paddingLeft: '0px' }}>
              {policyDetails?.sumInsuredHeaderSorted?.labelText}
            </TableCell>
            <TableCell style={{ paddingLeft: '2px' }}>
              {policyDetails?.sumInsuredHeaderSorted?.ValueText}
            </TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {labelValuePairDatas.map((labelValue, rowIndex) => (
            <TableRow key={rowIndex}>
              <TableCell padding="checkbox">
                <Checkbox
                  checked={isRowSelected(labelValue)}
                  onChange={(e) => handleCheckboxChange(labelValue, e.target.checked)}
                />
              </TableCell>
              <TableCell style={{ paddingLeft: '0px' }}>
                {labelValue?.description || '------------------------'}
              </TableCell>
              <TableCell style={{ paddingLeft: '2px' }}>
                {labelValue?.sumInsured}
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
}

export default SumInsuredLabelvaluepair;
